import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';

import { MainPage, ArticleList, NewsList, BlogList } from '../Listings';
import { PageReload } from '../../components/PageReload';
import { useContext } from 'react';
import { ApplicationContext } from '../../utils';
import { mkPagesMeta } from '../../__stubs__/mocks/pagesMeta';

export const RoutesNew = () => {
  const { search } = useLocation();
  const qs = new URLSearchParams(search);
  const {
    custom: { isNewDesignEnabled, newDesignSubdomains, subdomain },
  } = useContext(ApplicationContext);
  const isCorrectSubdomain = newDesignSubdomains?.length ? newDesignSubdomains.includes(subdomain) : true;
  const pagesMeta = mkPagesMeta().filter(pageMeta =>
    [
      '/forum-rieltorov/',
      '/forum-rieltorov-specialist/',
      '/forum-rieltorov-tendentsiy-rynka/',
      '/forum-rieltorov-gorodskaya-nedvizhimost/',
      '/forum-rieltorov-zagorodnaya-nedvizhimost/',
      '/forum-rieltorov-zarubezhnaya-nedvizhimost/',
      '/forum-rieltorov-ipoteka/',
    ].includes(pageMeta.pathname),
  );

  return (
    <Switch>
      <Route path={`/magazine/`} component={MainPage}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && (qs.get('tag') || qs.get('search')) && (
          <>
            <PageReload />
            <MainPage />
          </>
        )}
      </Route>

      <Route path={`/novosti/:id/`} strict exact component={NewsList}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
      </Route>
      <Route path={`/novosti/`} strict exact component={NewsList}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
      </Route>
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/novosti/" to="/novosti/" />

      <Route path={`/blogs-:path/`} strict exact component={BlogList}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
      </Route>
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/blogs-:path/" to="/blogs/" />

      <Route path={`/blogs/`} strict exact component={BlogList}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
      </Route>
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/blogs/" to="/blogs/" />

      {/* Поддерживает только "/moi-blog/" */}
      <Route path={`/moi-blog/`} strict exact component={BlogList}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
      </Route>
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/moi-blog/" to="/blogs/" />

      <Route path={`/magazine-:path/`} component={ArticleList}>
        {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
      </Route>

      {pagesMeta.map((pageMeta, index) => (
        <Route key={index} path={pageMeta.pathname}>
          {(!isNewDesignEnabled || !isCorrectSubdomain) && <PageReload />}
        </Route>
      ))}

      <Route>
        <PageReload />
        <MainPage />
      </Route>
    </Switch>
  );
};
